<form
  class="task-form"
  (ngSubmit)="submit()"
>
  <label class="task-form__field">
    <span>{{ i18n.t('task.form.field') }}</span>

    <select
      name="field"
      [(ngModel)]="fieldId"
      (ngModelChange)="fieldChanged()"
      required
    >
      <option [ngValue]="null">
        {{ i18n.t('task.form.selectField') }}
      </option>

      @for (field of fields; track field.id) {
        <option [ngValue]="field.id">
          {{ i18n.t('field.field') }}
          {{ field.number }}
        </option>
      }
    </select>
  </label>

  <label class="task-form__field">
    <span>{{ i18n.t('task.form.work') }}</span>

    <select
      name="type"
      [(ngModel)]="type"
      (ngModelChange)="typeChanged()"
      required
    >
      @for (
          fieldWorkType of fieldWorkTypes;
        track fieldWorkType.id
        ) {
        <option [value]="fieldWorkType.code">
          {{ taskTypeLabel(fieldWorkType.code) }}
        </option>
      }
    </select>
  </label>

  @if (sowSelected) {
    <label class="task-form__field">
      <span>Frucht</span>

      @if (fieldId === null) {
        <select disabled>
          <option>
            Zuerst Feld auswählen
          </option>
        </select>
      } @else if (cropLoading) {
        <select disabled>
          <option>
            Früchte werden geladen ...
          </option>
        </select>
      } @else if (cropError) {
        <div class="task-form__error">
          Früchte konnten nicht geladen werden.
        </div>
      } @else {
        <select
          name="crop"
          [(ngModel)]="cropId"
          required
        >
          <option [ngValue]="null">
            Frucht auswählen
          </option>

          @for (
              candidate of cropCandidates;
            track candidate.cropId
            ) {
            <option [ngValue]="candidate.cropId">
              {{ cropLabel(candidate.crop) }}

              @if (candidate.rating === 'recommended') {
                — Empfohlen
              } @else if (candidate.rating === 'possible') {
                — Möglich
              } @else {
                — Nicht empfohlen
              }
            </option>
          }
        </select>
        @if (selectedCropCode; as crop) {
          <div style="display:flex;align-items:center;gap:0.25rem;margin-top:0.4rem">
            <app-crop-icon [crop]="crop" />{{ cropLabel(crop) }}
          </div>
        }
      }
    </label>
  }

  <footer class="task-form__actions">
    <button
      class="task-form__secondary"
      type="button"
      (click)="cancel()"
    >
      {{ i18n.t('task.form.cancel') }}
    </button>

    <button
      class="task-form__primary"
      type="submit"
      [disabled]="!valid"
    >
      {{ i18n.t('task.form.save') }}
    </button>
  </footer>
</form>
